import {
  datatype,
  lorem,
} from 'faker'
import { FormikValues } from 'formik'

export interface Tenant {
  id: number
  domain: string
  customerId: number
  name: string
  timezone: string
  segment: string
  basisPointFee: number
  segmentCode: string
  issuerId?: number
  backOfficeEmail?: string
  leiCode?: string
  clearCode?: null
  capitalBasisEnabled: boolean
  longTermComplianceOnly: boolean
  currency: string
  passwordExpiryMonths: number
  enforceSeparationOfDuties: boolean
  isDemo: boolean
  defaultTPlusNDays: number
  pipelineOrgId?: number
  isTrial: boolean
  requiredRfqSignOffCount: number
  licences: string[]
  _links: any
}

export const mockTenant = (overrides?: Partial<Tenant>): Tenant => ({
  id: datatype.number(),
  domain: lorem.word(),
  currency: lorem.word(),
  customerId: datatype.number(),
  passwordExpiryMonths: datatype.number(),
  requiredRfqSignOffCount: datatype.number(),
  defaultTPlusNDays: datatype.number(),
  basisPointFee: datatype.number(),
  name: lorem.word(),
  segmentCode: lorem.word(),
  licences: [],
  timezone: lorem.word(),
  segment: lorem.word(),
  capitalBasisEnabled: datatype.boolean(),
  longTermComplianceOnly: datatype.boolean(),
  enforceSeparationOfDuties: datatype.boolean(),
  isDemo: datatype.boolean(),
  isTrial: datatype.boolean(),
  _links: {},
  ...overrides,
})

export interface TenantFormValues extends FormikValues {
  name: string
  domain: string
  isDemo: boolean
  isTrial: boolean
  timezone: string
  issuerId: number
  customerId?: number
  currency: string
  backOfficeEmail: string | string[]
  defaultTPlusNDays: number
  basisPointFee: number
  enforceSeparationOfDuties: boolean
  requiredRfqSignOffCount: number
  segmentCode: string
  passwordExpiryMonths: number
  capitalBasisEnabled: boolean
  longTermComplianceOnly: boolean
}

export const updateTenantInitialData: TenantFormValues = {
  domain: '',
  name: '',
  timezone: '',
  segmentCode: '',
  issuerId: 0,
  backOfficeEmail: '',
  capitalBasisEnabled: false,
  longTermComplianceOnly: false,
  currency: '',
  passwordExpiryMonths: 3,
  enforceSeparationOfDuties: false,
  isDemo: false,
  defaultTPlusNDays: 0,
  basisPointFee: 0,
  isTrial: false,
  requiredRfqSignOffCount: 1,
}

export interface Issuer {
  id: number
  name: string
}
